import { render, staticRenderFns } from "./RadUserInfoCard.vue?vue&type=template&id=11f56fdc&scoped=true"
import script from "./RadUserInfoCard.vue?vue&type=script&lang=js"
export * from "./RadUserInfoCard.vue?vue&type=script&lang=js"
import style0 from "./RadUserInfoCard.vue?vue&type=style&index=0&id=11f56fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f56fdc",
  null
  
)

export default component.exports